import { Observable } from "rxjs";
import {
  RealCostData,
  RealCostMultiplier,
  ResourceCostOverride
} from "../models/real-cost.model";

export abstract class RealCostRepository {
  abstract loadRealCost(
    contractCode: string
  ): Observable<RealCostData>;

  abstract saveMultipliers(
    contractId: number,
    multipliers: RealCostMultiplier[] | null,
    straight40?: boolean | null
  ): Observable<void>;

  abstract loadCostOverrides(contractId: number): Observable<ResourceCostOverride[]>;

  abstract saveCostOverrides(contractId: number, overrides: ResourceCostOverride[]): Observable<void>;

  abstract checkPageAccess(ruleCode: string): Observable<boolean>;
}
